// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiMintingClaimAction } from '../models/ApiMintingClaimAction';
import { HttpFile } from '../http/http';

export class ApiMintingClaimActionsResponse {
    'contract': string;
    'claim_id': number;
    'actions': Array<ApiMintingClaimAction>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "claim_id",
            "baseName": "claim_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "actions",
            "baseName": "actions",
            "type": "Array<ApiMintingClaimAction>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiMintingClaimActionsResponse.attributeTypeMap;
    }

    public constructor() {
    }
}
